import { render, staticRenderFns } from "./MessageStatus.vue?vue&type=template&id=5c76c77f&"
import script from "./MessageStatus.vue?vue&type=script&lang=js&"
export * from "./MessageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c76c77f')) {
      api.createRecord('5c76c77f', component.options)
    } else {
      api.reload('5c76c77f', component.options)
    }
    module.hot.accept("./MessageStatus.vue?vue&type=template&id=5c76c77f&", function () {
      api.rerender('5c76c77f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/MessageStatus.vue"
export default component.exports